import React from 'react';
import Modal from 'react-modal';
import styles from './DetalhesModal.module.css';

const DetalhesModal = ({ isOpen, onClose, pagamento }) => {
  if (!pagamento) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      contentLabel="Detalhes do Pagamento"
    >
      <h2>Detalhes do Pagamento</h2>
      <div className={styles.detalhes}>
        <p><strong>Aluno:</strong> {pagamento.student}</p>
        <p><strong>Tipo:</strong> {pagamento.type}</p>
        <p><strong>Valor:</strong> R$ {pagamento.amount.toFixed(2)}</p>
        <p><strong>Forma de Pagamento:</strong> {pagamento.paymentMethod}</p>
        <p><strong>Status:</strong> {pagamento.status}</p>
        <p><strong>Data/Hora:</strong> {pagamento.datetime}</p>
        <p><strong>Código:</strong> {pagamento.code}</p>
      </div>
      <div className={styles.actions}>
        <button className={styles.closeBtn} onClick={onClose}>Fechar</button>
        <button className={styles.receiptBtn} onClick={() => alert('Gerar recibo (em desenvolvimento)')}>Gerar Recibo</button>
      </div>
    </Modal>
  );
};

export default DetalhesModal;
